import { useMutation, useQuery } from '@tanstack/react-query';
import { getPrivateAxiosInstance } from '../../../axiosInstances/axiosPrivate';
import { AcademiaResponse } from '../../../types/common';
import { PurchaseHistory } from '../../../types/history';
import { returnQueryConfig } from '../../../utils/commonFunctions';

const usePurchaseActions = (whichAction: 'paymentInfoList' | '') => {
  // query function to fetch all the payments declared here
  const getPaymentInfoListHandler = useQuery({
    queryKey: ['payment-info-list'],
    queryFn: async (): Promise<
      AcademiaResponse<Array<PurchaseHistory> | null>
    > => {
      const response = await getPrivateAxiosInstance('finance').get(
        '/appointment/payment/info/list/'
      );

      return response.data;
    },

    ...returnQueryConfig(whichAction === 'paymentInfoList'),
  });

  // mutation function to create new payment declared here
  const createPaymentHandler = useMutation({
    mutationFn: async ({
      body,
    }: {
      body: {};
    }): Promise<AcademiaResponse<PurchaseHistory>> => {
      const response = await getPrivateAxiosInstance('finance').post(
        '/appointment/payment/info/create/',
        body
      );

      return response.data;
    },
  });

  return { getPaymentInfoListHandler, createPaymentHandler };
};

export default usePurchaseActions;
